<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item config-module="101402" :show-simple="false" :expand-adv="true" :custom-search-items="customSearchItems" @advSearchItemCallBack="toAdvancedQuery">
        <template slot="searchAreaHeader">
          <el-button no="showEditDialog" type="primary" @click="showEditDialog">{{ $t('Partners.openB2BAccount') }}</el-button>
          <el-button no="resetUserPwd" type="primary" @click="resetUserPwd">{{ $t('Partners.resetPassword') }}</el-button>
          <el-button v-show="isTP" no="modificationOfBookingAgents" type="primary" @click="modificationOfBookingAgents">{{ $t('Partners.modificationOfBookingAgents') }}</el-button>
          <el-button no="goBack" type="primary" @click="goBack">{{ $t('SeaExport.Return') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="101403"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="101403"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :total="total"
          @pagination="toAdvancedQuery()"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('Partners.openB2BSettings')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
      @close="closeEditDialog"
    >
      <div class="app-main-inner-row invite-set-password">
        <el-form label-width="70px" label-position="top">
          <el-form-item>
            <div class="custom-label-container">
              <span>{{ $t('CargoMsg.Cargo_Password') }}</span>
              <span v-if="hasNewB2B" class="randomClass">
                {{ $t('CargoMsg.Cargo_RandomPassword') }}
                <el-checkbox v-model="editDialog.randomPassword" no="randomPassword" @change="handleCheckRandomPass" />
              </span>
            </div>
            <el-input v-model="editDialog.form.password" no="password" type="password" :disabled="editDialog.passDisabled" />
          </el-form-item>
          <el-form-item v-show="isTP" :label="$t('CargoMsg.Cargo_BookingAgent')">
            <cargo-owned-branch-select
              :value="toNumArray(editDialog.form.bookingAgentBranchIds)"
              no="multipleBranchId"
              :select-type="selectTypeNames.basic_data_Office_All"
              :static-options="branchCompanyHierarchy ? currentOfficeList : null"
              :multiple="true"
              clearable
              :placeholder="$t('SystemMaintenance.PleaseSelectBookingAgent')"
              style="width: 380px;"
              @input="val=>{editDialog.form.bookingAgentBranchIds=toTxt(val)}"
            />
          </el-form-item>
          <!-- 开通新的独立站注册邀请时：添加可以选择的客户类型 -->
          <el-form-item v-if="hasNewB2B">
            <!-- <el-radio-group v-model="editDialog.form.companyType" class="companyTypeClass">
              <el-radio :label="0">{{ $t('Partners.isCustomer') }}</el-radio>
              <el-radio :label="1">{{ $t('Partners.isDesignationAgent') }}</el-radio>
              <el-radio :label="2">目的港代理</el-radio>
              <el-radio :label="3">收货人</el-radio>
            </el-radio-group> -->
            <el-checkbox-group v-model="editDialog.form.companyTypes" class="companyTypeClass">
              <el-checkbox :label="0" disabled>{{ $t('Partners.isCustomer') }}</el-checkbox>
              <el-checkbox :label="1">{{ $t('Partners.isDesignationAgent') }}</el-checkbox>
              <el-checkbox :label="2">{{ $t('CargoMsg.Cargo_DestinationAgent') }}</el-checkbox>
              <el-checkbox :label="3">{{ $t('SeaExport.Consignee') }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="ok" type="primary" @click="save">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 修改订舱代理弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="modifyBookingAgentDialog.visible"
      :title="$t('Partners.modificationOfBookingAgents')"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
      @close="closeModifyBookingAgentDialog"
    >
      <div class="app-main-inner-row modify-booking-agent">
        <el-form label-width="120px" label-position="top">
          <el-form-item :label="$t('CargoMsg.Cargo_BookingAgent')" required>
            <cargo-owned-branch-select
              :value="toNumArray(modifyBookingAgentDialog.form.bookingAgentBranchIds)"
              no="bookingAgentBranchIds"
              :select-type="selectTypeNames.basic_data_Office_All"
              :static-options="branchCompanyHierarchy ? currentOfficeList : null"
              :multiple="true"
              clearable
              :placeholder="$t('SystemMaintenance.PleaseSelectBookingAgent')"
              style="width: 100%;"
              @input="val=>{modifyBookingAgentDialog.form.bookingAgentBranchIds=toTxt(val)}"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="confirmModify" type="primary" @click="confirmModifyBookingAgent()">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancelModify" @click="modifyBookingAgentDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { validEmail } from '@/utils/validate'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { cache, cacheName } from '@/utils/cacheManager'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import {
  queryContactPageableFast,
  activeB2BAccountAuth,
  activeB2BAccountCompany,
  resetB2BUserPassword,
  updateContactBookingAgent
} from '@/api/partner/contact'
import { getCompanyOne } from '@/api/company'
import CargoOwnedBranchSelect from '@/components/Cargo/Common/CargoOwnedBranchSelect.vue'
import { getCacheListByKey } from '@/utils/basicDataCache'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'ContactList',
  components: { CargoOwnedBranchSelect, searchItem },
  data() {
    return {
      filter: {
        conditions: [],
        branchId: -1,
        pageNum: 1,
        pageSize: 50
      },
      hiddenConditions: [
        new AdvancedSearchOption(null, 'company.customer', 1).formatObj2Json()
      ],
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onRowDataChanged: event => {
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('baseInfo.partner.cmpIdx'),
          checkboxSelection: true,
          width: 55,
          headerCheckboxSelection: true,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false

        }, {
          headerName: this.$t('SeaExport.CustomerName'),
          field: 'companyChineseName',
          width: 200
        }, {
          headerName: this.$t('SeaExport.ChargeBranchId'),
          field: 'branchId',
          width: 200,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          }
        }, {
          headerName: this.$t('Payment.contactPerson'),
          field: 'contactPerson',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Role'),
          field: 'role',
          width: 200
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultContact',
          width: 200,
          valueFormatter: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('SeaExport.Tel'),
          field: 'telephone',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Fax'),
          field: 'fax',
          width: 200
        }, {
          headerName: 'Email',
          field: 'email',
          width: 200
        }, {
          headerName: this.$t('SeaExport.Mobile'),
          field: 'mobile',
          width: 200
        }, {
          headerName: this.$t('Partners.b2bUsers'),
          field: 'relateUserId',
          width: 200,
          valueFormatter: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          field: 'bookingAgentBranchIds',
          width: 300,
          cellRenderer: (params) => {
            const bookingAgentIds = params.value.split(',')
            if (!bookingAgentIds.length) return ''
            return bookingAgentIds.map(item => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', item, 'chineseName')
            }).join(',')
          },
          suppressColumnsToolPanel: this.isTP,
          hide: true
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      isTP: true,
      branchCompanyHierarchy: false,
      customSearchItems: [], // 自定义高级查询项
      editDialog: {
        visible: false,
        passDisabled: false,
        randomPassword: false,
        form: {
          password: '',
          bookingAgentBranchIds: '',
          companyTypes: [0]
        }
      },
      // 添加修改订舱代理弹窗数据
      modifyBookingAgentDialog: {
        visible: false,
        form: {
          bookingAgentBranchIds: '' // 支持多选的订舱代理ID数组
        }
      },
      hasNewB2B: Number(cache.hqConfig.get('HasNewB2B')) === 1
    }
  },
  computed: {
    currentOfficeList() {
      const allOffice = [...getCacheListByKey(TYPE_NAMES.basic_data_Office_All)]
      allOffice.sort((a, b) => a.level - b.level)
      const keySet = new Set()
      for (const office of this.$store.state.user.userInfo.currentUserOfficeList) {
        keySet.add(office.uuid)
      }
      const result = []
      for (const office of allOffice) {
        if (keySet.has(office.uuid)) {
          result.push(office)
        } else if (office.parentBranchUuid && keySet.has(office.parentBranchUuid)) {
          keySet.add(office.uuid)
          result.push(office)
        }
      }
      return result
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isTP = String(cache.config.get('ToExoSystem')) === 'TP'
    this.branchCompanyHierarchy = Number(cache.config.get('BranchCompanyHierarchy')) === 1
    await this.getSearchField()
  },
  methods: {
    toAdvancedQuery(conditions) {
      if (conditions instanceof Array) {
        for (const option of conditions) {
          if (option.fieldName === 'contact.relateUserId') {
            option.operator = option.value ? AdvancedSearchConsts.OPERATOR_UNEQUAL.code : AdvancedSearchConsts.OPERATOR_EQUAL.code
            option.value = 0
          } else if (option.fieldName === 'company.CMP_IDX' && option.fieldType === 'FIELD_SEA_DEST_AGENT') {
            this.hiddenConditions = null
          }
        }
        if (this.hiddenConditions) {
          conditions = conditions.concat(this.hiddenConditions)
        }
        this.filter.conditions = conditions
      }
      const loading = getLoading4Cxt(this)
      queryContactPageableFast(this.filter).then(res => {
        const data = res.data
        this.rowData = data.list
        this.filter.pageNum = data.pageNum
        this.filter.pageSize = data.pageSize
        this.total = Number(data.total)
      }).finally(() => {
        loading.close()
      })
    },
    showEditDialog() {
      const loading = getLoading4Cxt(this)
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        loading.close()
        return
      }
      for (const item of rows) {
        if (item.relateUserId) {
          this.$message.warning(this.$t('Partners.selectNotOpenedB2BAccount'))
          loading.close()
          return
        }
        if (!validEmail(item.email)) {
          this.$message.warning(item.contactPerson + this.$t('Partners.emailAddressIsIllegal'))
          loading.close()
          return
        }
      }
      const companyUuid = rows[rows.length - 1].companyUuid
      getCompanyOne(companyUuid).then(res => {
        if (res.data) {
          if (res.data.approvedState === 0 || res.data.approvedState === 2) {
            this.$message.warning(this.$t('Partners.selectAnApprovedPartner'))
            return
          }
          // 打开弹框：重置默认参数
          this.editDialog.form = { password: '', companyTypes: [0], bookingAgentBranchIds: res.data.bookingAgentBranchIds }
          this.modifyBookingAgentDialog.form = { bookingAgentBranchIds: res.data.bookingAgentBranchIds }
          this.editDialog.visible = true
        }
      }).finally(() => {
        if (loading) {
          loading.close()
        }
      })
    },
    async save() {
      const loading = getLoading4Cxt()
      const password = this.editDialog.form.password
      // 未开通新B2B, 或者开通了新B2B 但没有勾选随机密码 时，密码必填
      if ((!this.hasNewB2B || !this.editDialog.randomPassword) && !password) {
        this.$message.warning(this.$t('Partners.inputAPassword'))
        loading.close()
        return
      }
      if (password) {
        if (!this.checkPassword(password)) {
          this.$message.warning(this.$t('myResources.password_notCompliant'))
          loading.close()
          return
        }
      }
      if (this.isTP && !this.editDialog.form.bookingAgentBranchIds) {
        this.$message.warning(this.$t('Partners.batchSelectBookingAgent'))
        loading.close()
        return
      }
      const rows = this.gridApi.getSelectedRows()
      const contactUuidList = Array.from(rows, p => p.uuid)
      const activeB2BMode = cache.config.get('activeB2BMode')
      const companyTypes = this.editDialog.form.companyTypes
      const bookingAgentBranchIds = this.editDialog.form.bookingAgentBranchIds
      if (activeB2BMode === 'auth') {
        await activeB2BAccountAuth({ contactUuidList, password, companyTypes, bookingAgentBranchIds }).finally(() => {
          if (loading) {
            loading.close()
          }
        })
      } else if (activeB2BMode === 'company') {
        await activeB2BAccountCompany({ contactUuidList, password, bookingAgentBranchIds }).finally(() => {
          if (loading) {
            loading.close()
          }
        })
      }
      this.$message.success(this.$t('Partners.accountOpenedSuccessfully'))
      this.toAdvancedQuery(this.filter.conditions)
      this.editDialog.visible = false
    },
    checkPassword(val) {
      if (!val) return false
      // 检查长度是否在8-20之间
      if (val.length < 8 || val.length > 20) return false
      // 检查是否包含数字
      if (!/\d/.test(val)) return false
      // 检查是否包含小写字母
      if (!/[a-z]/.test(val)) return false
      // 检查是否包含大写字母
      if (!/[A-Z]/.test(val)) return false
      return true
    },
    resetUserPwd() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Partners.selectAContact'))
        return
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('Partners.oneContactPasswordCanResetATime'))
        return
      }
      const row = rows[0]
      if (!row.relateUserId) {
        this.$message.warning(this.$t('Partners.notOpenedB2BAccount'))
        return
      }
      this.$confirm(this.$t('Partners.confirmToReset') + '【' + row.contactPerson + '】' + this.$t('Partners.yourLoginPassword'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const companyName = await getCompanyOne(row.companyUuid).then(res => res.data.chineseName)
        await resetB2BUserPassword({ companyName, email: row.email }).then(res => {
          this.$message.success(this.$t('Partners.openResetPasswordLink'))
        })
      }).catch(() => { })
    },
    goBack() {
      this.$emit('back', false)
    },
    // 选中随机密码改变密码框
    handleCheckRandomPass(val) {
      this.editDialog.passDisabled = val
      if (val) {
        this.editDialog.form.password = ''
      }
    },
    // 关闭弹框的时候：初始化参数
    closeEditDialog() {
      this.editDialog.randomPassword = false
      this.editDialog.passDisabled = false
      this.editDialog.form.password = false
    },
    modificationOfBookingAgents() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAtLeastOneRecord'))
        return
      }
      if (rows.length === 1) {
        this.modifyBookingAgentDialog.form = { bookingAgentBranchIds: rows[0].bookingAgentBranchIds }
      }
      this.modifyBookingAgentDialog.visible = true
    },
    closeModifyBookingAgentDialog() {
      // 重置表单数据
      this.modifyBookingAgentDialog.form.bookingAgentBranchIds = ''
    },
    async getSearchField() {
      if (this.isTP) {
        this.customSearchItems.push(
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'office',
            'subType': {
              'includeChildOffice': true // 是否包含下属公司
            },
            'itemCondition': [
              {
                'code': '=',
                'chineseName': '等于',
                'englishName': 'Equal',
                'children': null,
                'selected': false
              },
              {
                'code': '!=',
                'chineseName': '不等于',
                'englishName': 'Unequal',
                'children': null,
                'selected': false
              },
              {
                'code': 'IN',
                'chineseName': '包含',
                'englishName': 'In',
                'children': null,
                'selected': false
              }
            ],
            'fieldType': 'FIELD_OP_OFFICE',
            'defaultConditionVal': '',
            'itemName': 'company.bookingAgentBranchId',
            'itemLabel': 'CargoMsg.Cargo_BookingAgent',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          }
        )
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    },
    confirmModifyBookingAgent() {
      // 验证是否选择了订舱代理
      if (!this.modifyBookingAgentDialog.form.bookingAgentBranchIds) {
        this.$message.warning(this.$t('Partners.batchSelectBookingAgent'))
        return
      }

      // 二次确认
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureModifyRuleConfigTips'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.saveModifyBookingAgent()
      }).catch(() => {
        // 用户取消操作
      })
    },
    async saveModifyBookingAgent() {
      const loading = getLoading4Cxt(this)
      try {
        const rows = this.gridApi.getSelectedRows()
        const contactUuidList = rows.map(row => row.uuid)
        const bookingAgentBranchIds = this.modifyBookingAgentDialog.form.bookingAgentBranchIds

        await updateContactBookingAgent({ contactUuidList, bookingAgentBranchIds })

        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.modifyBookingAgentDialog.visible = false
        // 刷新数据
        this.toAdvancedQuery(this.filter.conditions)
      } finally {
        loading.close()
      }
    }
  }
}
</script>
<style lang="scss">
.invite-set-password {
  .el-form-item--mini .el-form-item__label {
    width: 100%;
  }
  .randomClass {
    float: right;
  }
  .custom-label-container {
    color: black;
  }
  .companyTypeClass {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .el-checkbox {
      margin-right: 10px;
    }
  }
}

.modify-booking-agent {
  .el-form-item__label {
    color: black;
    font-weight: bold;
  }
}
</style>
